import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { empModulo } from '../../../diccionarios/empModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ReportesService } from '../../../services/administrador/reportes.service';
import { EmpleadoModel } from '../../../models/empleadoModel';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {

  formulario: FormGroup;

  mostrarCard: boolean = true;
  EmpleadoMo;
  resposiveFull: string;
  empModulo: any = {};

  //* GRID
  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  listaVacia: boolean = true;
  loading: boolean = false;
  textoBuscar: string;

  dataEdit: any = {};
  arrayEdit: any[] = [];
  // disableRefreshButtons: boolean;

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _reporteService: ReportesService
  ) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.formulario = this.fb.group({
      numeroReuqisicion: ['', [Validators.required]],
      puntoReorden: ['', [Validators.required]],
    });
    this.cargarGrid();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.anularHistorial.bind(this),
          label: 'Anular Historial',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-primary btn-block',//'btn btn-danger btn btn-block'
        }
      },
      // {
      //   headerName: "Button Column",
      //   field: "button",
      //   cellRenderer: function(params) {
      //     if (params.data.estado) {
      //       return '<button @click=&quot;disabledButton()&quot; type="button">Enabled</button>';
      //     } else {
      //       return '<button @click=&quot;disabledButton()&quot; disabled type="button">Disabled</button>';
      //     }
      //   }
      // },
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      /*{
        headerName: 'ARTICULO',
        sortable: true,
        width: 180,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
        valueGetter: function (params) {
          // debugger
          let data = params.data;
          let seab = data.seab;
          let cntr = data.cntr;
          if(seab != undefined && seab != '' && cntr != undefined && cntr != ''){
            return seab + ' / ' + cntr;
          } else {
            if(cntr != undefined && cntr != ''){
              return seab + ' / ' + cntr;
            } else {
              return seab;
            }
          }
         
        }
      },*/
      {
        headerName: 'Fecha',
        field: 'fechaPrimerContrato',
        filter: true,
        width: 150,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha de cambio',
        field: 'fechaCambio',
        sortable: true,
        filter: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
        valueGetter: function(params) {
          let cadena = params.data.fechaCambio;
          if(cadena !== null && cadena !== undefined && cadena !== '') {
            return cadena.substring(0, 19).replace('T', ' ');
          }
          return cadena;
        }
      },
      {
        headerName: 'Tipo de Empleado',
        field: 'tipoEmpleado',
        sortable: true,
        filter: true,
        width: 220,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        width: 250,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Dirección',
        field: 'direccion',
        sortable: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Dirección Domicilio',
        field: 'direccionDomicilio',
        sortable: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'País Nacimiento',
        field: 'paisNacimiento',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Provincia de nacimiento',
        field: 'provinciaNacimiento',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Región Domicilio',
        field: 'regionDomicilio',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Género',
        field: 'genero',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'e-mail',
        field: 'email',
        sortable: true,
        width: 230,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha primer contrato',
        field: 'fechaPrimerContrato',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha ultimo contrato',
        field: 'fechaUltimoContrato',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código empresa',
        field: 'empresa.codEmpresa',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción empresa',
        field: 'empresa.descripcion',
        sortable: true,
        width: 230,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Codigo Costo',
        field: 'codCCosto',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Costo',
        field: 'dscaCCosto',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Codigo Costo',
        field: 'codCargo',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Cargo',
        field: 'dscaCargo',
        sortable: true,
        width: 230,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Codigo Departamento',
        field: 'codDepartamento',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Departamento',
        field: 'dscaDepartamento',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Código Localidad',
        field: 'codLocalidad',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripción Localidad',
        field: 'dscaLocalidad',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Reporta A',
        field: 'reportaA',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estatus Empleado',
        field: 'statusEmpleado',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empresa solicitante',
        field: 'empresaSolicita',
        sortable: true,
        width: 180,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Deapartamento solcitante',
        field: 'departamentoSolicitaDsca',
        sortable: true,
        width: 320,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Empleado solicitante',
        field: 'empleadoSolicitaDsca',
        sortable: true,
        width: 320,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Realizó Cambio',
        field: 'userChangeBy',
        sortable: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Realizó Inactivación',
        field: 'userInhabilita',
        sortable: true,
        width: 200,
        cellStyle: this.changeCellColor.bind(this),
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  changeCellColor(params) {
    // debugger
    let data = params.data;
    if (data.color != undefined) {
      if (data.color === 2) {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else if (data.color === 1) {
        return {
          'background-color': '#cff0ec',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  disabledButton(params) {
    let data = params.data;
    if (data.estado != undefined) {
      return (data.estado === true) ? false : true;
    }
    return false;
  }
 
  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getDataRequisicion() {
    this.loading = true;
    let cedula = this.formulario.get('numeroReuqisicion').value;
    this._reporteService.getReporteByCed(cedula).subscribe((res: EmpleadoModel[]) => {
      console.log(res);
      this.loading = false;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.rowData = this.addSecuencial();
        this.rowData = this.setColorAtivosIncativos();
      } else {
        this.listaVacia = true;
      }
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  addSecuencial() {
    let conunt = 0;
    let arraSecuencial = [];
    arraSecuencial = this.rowData.map((e) => {
      e.secuencial = conunt++;
      return e;
    });
    return arraSecuencial;
  }

  setColorAtivosIncativos() {
    const fechaActual = new Date();
    let dataColor = [];
    let dataNoColor = [];
    let dataFinal = [];
    for (let i = 0; i < this.rowData.length; i++) {
      const e = this.rowData[i];
      let finicio = new Date(e.fechaIngreso);
      let ffin = new Date(e.fechaSalida);
      if(fechaActual > ffin) {
        e.color = 0;
        dataNoColor.push(e);
      } else {
        e.color = e.estado === true ? 1 : 2;
        dataColor.push(e);
      }
    }
    // debugger
    dataFinal = dataFinal.concat(dataColor, dataNoColor);
    return dataFinal;
  }

  callModal({ rowData }) {
    this.dataEdit = rowData;
    this.formulario.get('puntoReorden').setValue(rowData.puntoReorden);
    document.getElementById('abrirModal').click();
  }

  updatePuntoReorden() {
    let puntoReorden = this.formulario.get('puntoReorden').value;
    this.dataEdit.puntoReorden = puntoReorden;
    this.dataEdit.modificado = true;
    let sec = this.dataEdit.secuencial;
    const index = this.rowData.findIndex((e) => e.secuencial === sec);
    this.rowData.splice(index, 1, this.dataEdit);
    this.gridApi.setRowData(this.rowData);
    this.dataEdit = {};
    document.getElementById("cerrarModal").click();
  }

  downloadHistoricoExcel() {
    this.loading = true;
    this._reporteService.getReporteExcelHistorico().subscribe((res: any) => {
      this.loading = false;
      // debugger;
      this._util.descargarArchivo(res.clave, res.valor);
    }, (err) => {
      console.log(err);
      this.loading = false;
      // this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  anularHistorial({ rowData }) {
    if(!rowData.estado) {
      this._util.mensajeErroToast('El registro del historial se encuentra anulado. ');
      return 
    }
    const empleadoPk = {
      codEmpleado:rowData.codEmpleado,
      fechaCambio:rowData.fechaCambio
    };
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea anular el siguiente registro ?',
        text: '',
        action: 'Anular',
        funcion: this._reporteService.anularHistorial(empleadoPk),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.getDataRequisicion();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

}
